import React, { Component } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Tooltip from "@material-ui/core/Tooltip";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Alert,
} from "reactstrap";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

import { getSchemelist } from "store/scheme/actions";
import { getcyclelist } from "store/cycle/actions";
// import { getSamplelist } from "store/sample/actions";
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import { getSamplelist, updateSampleList } from "store/sample/actions";

import {
  getroundlist,
  addNewRoundList,
  updateRoundList,
  deleteRound,
} from "store/rounds/actions";

import { isEmpty, size } from "lodash";
import DeleteModal from "components/Common/DeleteModal";
import "assets/scss/table.scss";
import moment from "moment";
class InstrumentType extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.handleSchemeChange = this.handleSchemeChange.bind(this);
    this.state = {
      statisticsStatusMap: {},
      filteredCycleList: this.props.CycleList,
      filteredSampleList: this.props.ListUnitt,
      selectedRound: null,
      isEdit: false,
      organization_name: "",
      selectedSchemeId: "", // New state
      selectedFormSchemeId: "", // for modal form
      idFilter: "",
      roundsFilter: "",
      schemenameFilter: "",
      cyclenoFilter: "",
      round_sample_condition: "",
      sampleFilter: "",
      participantsFilter: "",
      issuedateFilter: "",
      closingdateFilter: "",
      notesFilter: "",
      statusFilter: "",
      errorMessage: "",
      RoundList: [],
      round: [],
      SchemeList: [],
      CycleList: [],
      // sample: [],
      ListUnitt: [],
      methodlist: "",
      modal: false,
      deleteModal: false,
      // ✅ "Open For" sub-modal state (Customer Service / Participant / Both)
      openForModal: false,
      pendingFormik: null,
      filters: {
        name: "",
        landline: "",
        email: "",
        address: "",
        city: "",
        type: "",
      },
      currentPage: 1,
      itemsPerPage: 100,
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
      successMessage: "",
    };

    this.toggle = this.toggle.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
    this.onClickStatistics = this.onClickStatistics.bind(this);
  }

  checkStatisticsForRounds = async (rounds) => {
    try {
      const closedRounds = rounds.filter((r) => r.status === "Closed");
      console.log("Closed Rounds:", closedRounds);

      if (closedRounds.length === 0) return;

      const requests = closedRounds.map((round) => {
        const apiUrl =
          round.scheme_type === "Identification"
            ? `https://externalqcapi.com/api/registration-admin/getMicroStatistics/${round.id}`
            : `https://externalqcapi.com/api/registration-admin/getStatistics/${round.id}`;

        return axios
          .get(apiUrl)
          .then((res) => {
            console.log(
              `Round ${round.id} (${round.scheme_type}) response:`,
              res.data,
            );
            const exists =
              res.data?.status === 200 &&
              Array.isArray(res.data?.data) &&
              res.data.data.length > 0;
            console.log(`Round ${round.id} exists:`, exists);
            return { id: round.id, exists };
          })
          .catch((err) => {
            console.log(
              `Round ${round.id} ERROR:`,
              err.response?.status,
              err.message,
            );
            return { id: round.id, exists: false };
          });
      });

      const results = await Promise.all(requests);
      console.log("Final Map:", results);

      const statisticsStatusMap = {};
      results.forEach((r) => {
        statisticsStatusMap[r.id] = r.exists;
      });

      this.setState({ statisticsStatusMap }, () => {
        console.log(
          "✅ STATE UPDATED - statisticsStatusMap:",
          this.state.statisticsStatusMap,
        );
      });
    } catch (error) {
      console.log("Error:", error);
    }
  };
  handleSchemeChange = (e) => {
    const selectedSchemeId = parseInt(e.target.value);
    this.setState({ selectedFormSchemeId: selectedSchemeId }); // ✅ only affect modal

    console.log("Selected Scheme ID:", selectedSchemeId);
    console.log("CycleList:", this.props.CycleList);
    console.log("ListUnitt (Samples):", this.props.ListUnitt);
    console.log("RoundList:", this.props.RoundList);

    // ✅ Ensure `CycleList` and `ListUnitt` exist before filtering
    if (
      !this.props.CycleList ||
      !this.props.ListUnitt ||
      !this.props.RoundList
    ) {
      console.error("Data is missing!");
      return;
    }

    // Filter CycleList and SampleList based on the selected scheme
    const filteredCycleList = this.props.CycleList.filter(
      (cycle) => cycle.scheme_id === selectedSchemeId,
    );

    console.log("Filtered Cycle List:", filteredCycleList);
    const filteredSampleList = this.props.ListUnitt.filter(
      (sample) =>
        sample.scheme_id === selectedSchemeId &&
        !this.props.RoundList.some(
          (round) =>
            round.sample === sample.samplename &&
            round.id !== this.state.selectedRound?.id, // Exclude current round's sample
        ),
    );

    console.log("Filtered Sample List:", filteredSampleList);

    console.log("Final Filtered Sample List:", filteredSampleList);
    console.log("Filtered sample List:", filteredSampleList);

    this.setState({
      filteredCycleList,
      filteredSampleList,
    });
  };

  async componentDidMount() {
    const { organization_name } = this.props.match.params;
    const { currentPage, itemsPerPage, user_id } = this.state; // pagination info

    // Only set state if organization_name is empty
    if (!this.state.organization_name) {
      this.setState({ organization_name });
    }

    const {
      onGetRoundList,
      onGetgetschemelist,
      onGetgetcyclelist,
      onGetgetSamplelistlist,
    } = this.props;

    // Fetch Round list with pagination
    await onGetRoundList(user_id, currentPage, itemsPerPage);

    if (this.props.RoundList?.length > 0) {
      await this.checkStatisticsForRounds(this.props.RoundList);
    }
    // Fetch other lists (no pagination)
    onGetgetschemelist(user_id);
    onGetgetcyclelist(user_id);
    onGetgetSamplelistlist(user_id);
  }
  handlePageChange = (pageNumber) => {
    this.setState({ currentPage: pageNumber }, () => {
      const { onGetRoundList } = this.props;
      const { user_id, currentPage, itemsPerPage, filters } = this.state;
      onGetRoundList(user_id, currentPage, itemsPerPage, filters);
    });
  };
  handleFilterChange = (field, value) => {
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          [field]: value,
        },
        currentPage: 1, // reset page on filter change
      }),
      () => {
        const { currentPage, itemsPerPage, filters, user_id } = this.state;
        const roundId = this.props.match.params.id;

        // 🔄 Refresh both lists
        this.props.onGetRoundList(roundId, currentPage, itemsPerPage, filters);
      },
    );
  };

  toggleDeleteModal = () => {
    this.setState((prevState) => ({
      deleteModal: !prevState.deleteModal,
    }));
  };

  handleDeleteRound = () => {
    const { onDeleteRound, onGetRoundList } = this.props;
    const { RoundList } = this.state;
    if (RoundList.id !== undefined) {
      onDeleteRound(RoundList);
      setTimeout(() => {
        onGetRoundList(this.state.user_id);
      }, 1000);
      this.setState({ deleteModal: false });
    }
  };

  // onClickDelete = RoundList => {
  //   this.setState({ RoundList: RoundList });
  //   this.setState({ deleteModal: true });
  // };

  onClickDelete = (RoundList) => {
    // Allowed statuses for deletion
    const allowedStatuses = ["Open", "Closed", "Report Available"];

    if (allowedStatuses.includes(RoundList.status)) {
      this.setState({
        errorMessage: `Cannot delete. Round status is ${RoundList.status}`,
      });
      // Clear error message after 2 seconds
      setTimeout(() => {
        this.setState({ errorMessage: "" });
      }, 2000);
    } else {
      this.setState({ RoundList: RoundList });
      this.setState({ deleteModal: true });
    }
  };

  displaySuccessMessage = (message) => {
    this.setState({ successMessage: message });

    setTimeout(() => {
      this.setState({ successMessage: "", modal: false });
    }, 3000);
  };

  handleFilterChange = (filterName, e) => {
    this.setState({ [filterName]: e.target.value });
  };
  onClickStatistics = (round) => {
    if (round && round.id) {
      const updatedRound = {
        ...round,
        status: "Statistics Done",
      };

      this.props.onUpdateRound(round.id, updatedRound);

      // Reload RoundList after update
      setTimeout(() => {
        this.props.onGetRoundList(this.state.user_id);
      }, 500);

      // Navigate after update
      setTimeout(() => {
        this.props.history.push(
          `/${this.state.organization_name}/statistics/${round.id}`,
        );
      }, 600); // Slight delay to give update a chance
    }
  };

  onClickReport = (id) => {
    this.props.history.push(
      `/${this.state.organization_name}/slectValues/${id}`,
    );
  };

  toggle(round) {
    const { onGetgetschemelist } = this.props;

    // Ensure the scheme list is fetched
    onGetgetschemelist(this.state.user_id);

    if (round && round.id) {
      this.setState(
        {
          modal: true,
          selectedRound: round,
          selectedFormSchemeId: round.scheme,
          selectedCycle: round.cycle_no,
          selectedSample: round.sample || "", // Set the previously selected sample
          selectedSampleCondition: round.round_sample_condition || "",
          isEdit: true,
        },
        () => {
          console.log("Selected Sample in State:", this.state.selectedSample);
          // ⏳ Delay the execution of handleSchemeChange to ensure state updates first
          setTimeout(() => {
            this.handleSchemeChange({ target: { value: round.scheme } });
          }, 100);
        },
      );
    } else {
      this.setState({
        modal: true,
        selectedRound: null,
        selectedSchemeId: null,
        selectedCycle: null,
        selectedSample: null,
        isEdit: false,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.RoundList !== this.props.RoundList) {
      if (this.props.RoundList?.length > 0) {
        this.checkStatisticsForRounds(this.props.RoundList);
      }

      this.setState({ RoundList: this.props.RoundList });
    }

    if (
      !isEmpty(this.props.SchemeList) &&
      size(prevProps.SchemeList) !== size(this.props.SchemeList)
    ) {
      this.setState({ SchemeList: this.props.SchemeList });
    }
    if (
      !isEmpty(this.props.CycleList) &&
      size(prevProps.CycleList) !== size(this.props.CycleList)
    ) {
      this.setState({ CycleList: this.props.CycleList });
    }
    if (
      !isEmpty(this.props.ListUnitt) &&
      size(prevProps.ListUnitt) !== size(this.props.ListUnitt)
    ) {
      this.setState({ ListUnitt: this.props.ListUnitt });
    }
    if (prevProps.SchemeList !== this.props.SchemeList) {
      this.setState({ SchemeList: this.props.SchemeList });
    }
  }
  onPaginationPageChange = (page) => {
    if (
      this.node &&
      this.node.current &&
      this.node.current.props &&
      this.node.current.props.pagination &&
      this.node.current.props.pagination.options
    ) {
      this.node.current.props.pagination.options.onPageChange(page);
    }
  };
  closeModal = () => {
    this.setState({ modal: false });
  };

  // ✅ "Open For" sub-modal handlers -----------------------------------
  // Called when the user picks Customer Service / Participant / Both.
  // Commits status="Open" plus open_for=<choice> onto the *same* Formik
  // form instance that triggered the modal, then closes the sub-modal.
  handleOpenForSelect = (option) => {
    const { pendingFormik } = this.state;
    if (pendingFormik) {
      pendingFormik.setFieldValue("status", "Open");
      pendingFormik.setFieldValue("open_for", option);
    }
    this.setState({ openForModal: false, pendingFormik: null });
  };

  // Called on cancel/close (X button, backdrop, etc). Since we never
  // wrote "Open" into the Formik field, the status select simply stays
  // on whatever it was before the user picked "Open".
  closeOpenForModal = () => {
    this.setState({ openForModal: false, pendingFormik: null });
  };
  // ----------------------------------------------------------------------

  render() {
    console.log(
      "RENDER - statisticsStatusMap:",
      this.state.statisticsStatusMap,
    );
    console.log(
      "RENDER - Round 1 isCalculated:",
      this.state.statisticsStatusMap?.[1],
    );
    console.log(
      "RENDER - Round 4 isCalculated:",
      this.state.statisticsStatusMap?.[4],
    );
    const { SearchBar } = Search;
    const { filters, currentPage, itemsPerPage } = this.state;
    const { RoundList, SchemeList, CycleList, ListUnitt } = this.props;
    console.log(
      "RENDER - All rounds status:",
      (RoundList || []).map((r) => ({
        id: r.id,
        status: r.status,
        scheme_type: r.scheme_type,
      })),
    );
    // console.log('SchemeList in render:', SchemeList);

    const { isEdit, deleteModal, errorMessage } = this.state;
    const round = this.state.round;
    const {
      onGetRoundList,
      onGetgetschemelist,
      onGetgetcyclelist,
      onGetgetSamplelistlist,
      onAddNewRound,
      onUpdateRound,
    } = this.props;

    const {
      idFilter,
      roundsFilter,
      schemenameFilter,
      cyclenoFilter,
      sampleFilter,
      participantsFilter,
      issuedateFilter,
      closingdateFilter,
      notesFilter,
      statusFilter,
    } = this.state;

    const feedbackListColumns = [
      {
        text: "ID",
        dataField: "id",
        sort: true,
        hidden: false,
        formatter: (cellContent, methodlist) => <>R-{methodlist.id}</>,
        headerFormatter: (column, colIndex) => {
          return (
            <>
              <div style={{ textAlign: "center", marginBottom: "5px" }}>
                {column.text}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <input
                  type="text"
                  value={this.state.idFilter}
                  onChange={(e) => this.handleFilterChange("idFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "70px",
                    margin: "auto",
                  }}
                />
              </div>
            </>
          );
        },
      },
      {
        dataField: "rounds",
        text: "Round No",
        sort: true,
        headerFormatter: (column, colIndex) => {
          return (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.roundsFilter}
                  onChange={(e) => this.handleFilterChange("roundsFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          );
        },
      },
      {
        dataField: "scheme_name",
        text: "Scheme Name",
        sort: true,
        headerFormatter: (column, colIndex) => {
          return (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.schemenameFilter}
                  onChange={(e) =>
                    this.handleFilterChange("schemenameFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          );
        },
      },
      {
        dataField: "cycle_no",
        text: "Cycle Number",
        sort: true,
        headerFormatter: (column, colIndex) => {
          return (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.cyclenoFilter}
                  onChange={(e) => this.handleFilterChange("cyclenoFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          );
        },
      },
      {
        dataField: "sample",
        text: "Sample Name",
        sort: true,
        headerFormatter: (column, colIndex) => {
          return (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.sampleFilter}
                  onChange={(e) => this.handleFilterChange("sampleFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          );
        },
      },
      {
        dataField: "participantsSummary",
        text: "Participants Overview",
        sort: false,
        formatter: (cell, row) => {
          return (
            <div style={{ textAlign: "center" }}>
              {/* 🧪 Total Labs */}
              <Tooltip title="Total Labs" arrow>
                <Link
                  to={`/round-participant-list/${row.id}`}
                  style={{
                    textDecoration: "underline",
                    color: "#0000CD",
                    margin: "0 5px",
                  }}
                >
                  {row.nooflabs}
                </Link>
              </Tooltip>
              /{/* 💾 Saved */}
              <Tooltip title="Saved Participants" arrow>
                <Link
                  to={`/saved-participants/${row.id}`}
                  style={{
                    textDecoration: "underline",
                    color: "orange",
                    margin: "0 5px",
                  }}
                >
                  {row.SavedResults}
                </Link>
              </Tooltip>
              /{/* ✅ Submitted */}
              <Tooltip title="Submitted Participants" arrow>
                <Link
                  to={`/submitted-participants/${row.id}`}
                  style={{
                    textDecoration: "underline",
                    color: "green",
                    margin: "0 5px",
                  }}
                >
                  {row.noofresults}
                </Link>
              </Tooltip>
              /{/* ❌ Pending */}
              <Tooltip title="Pending Submission" arrow>
                <Link
                  to={`/pending-submission/${row.id}`}
                  style={{
                    textDecoration: "underline",
                    color: "red",
                    margin: "0 5px",
                  }}
                >
                  {row.noofresultsnotsubmitted}
                </Link>
              </Tooltip>
            </div>
          );
        },
        headerFormatter: (column, colIndex) => {
          return (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "5px",
                  gap: "10px",
                }}
              >
                <input
                  type="text"
                  value={this.state.participantsFilter}
                  onChange={(e) =>
                    this.handleFilterChange("participantsFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "160px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          );
        },
        headerAlign: "center",
        align: "center",
      },
      {
        dataField: "issue_date",
        text: "Issue Date",
        sort: true,
        headerFormatter: (column, colIndex) => {
          return (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.issuedateFilter}
                  onChange={(e) =>
                    this.handleFilterChange("issuedateFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          );
        },
        formatter: (cellContent, methodlist) => (
          <span>{moment(methodlist.issue_date).format("DD-MMM-YY")}</span>
        ),
      },
      {
        dataField: "closing_date",
        text: "Closing Date",
        sort: true,
        headerFormatter: (column, colIndex) => {
          return (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.closingdateFilter}
                  onChange={(e) =>
                    this.handleFilterChange("closingdateFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          );
        },
        formatter: (cellContent, methodlist) => (
          <span>{moment(methodlist.closing_date).format("DD-MMM-YY")}</span>
        ),
      },
      {
        dataField: "status",
        text: "Status",
        sort: true,
        headerFormatter: (column, colIndex) => {
          const canShowReportAvailable = this.props.RoundList?.some(
            (round) => round.status === "Statistics Done",
          );
          return (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <select
                  value={this.state.statusFilter}
                  onChange={(e) => this.handleFilterChange("statusFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                >
                  <option value="">All</option>
                  <option value="Created">Created</option>
                  <option value="Ready">Ready</option>
                  <option value="Open">Open</option>
                  <option value="Closed">Closed</option>
                  <option value="Statistics Done">Statistics Done</option>
                  {canShowReportAvailable && (
                    <option value="Report Available">Report Available</option>
                  )}
                </select>
              </div>
            </div>
          );
        },
        formatter: (cellContent, methodlist) => (
          <span>{methodlist.status || "Unknown"}</span>
        ),
      },
      {
        dataField: "menu",
        isDummyField: true,
        editable: false,
        text: "Action",
        headerStyle: {
          textAlign: "center",
          verticalAlign: "middle",
        },
        formatter: (cellContent, round) => {
          const { organization_name } = this.state;

          const isCalculated =
            this.state.statisticsStatusMap?.[round.id] === true;
          console.log(
            `Row round.id: ${
              round.id
            }, isCalculated: ${isCalculated}, map value: ${
              this.state.statisticsStatusMap?.[round.id]
            }, full map:`,
            this.state.statisticsStatusMap,
          );

          return (
            <div
              className="d-flex gap-3 ml-3"
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <Tooltip title="Add Participants">
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    if (!this.state.organization_name) {
                      return;
                    }
                    const url = `/${this.state.organization_name}/add-labs-round-page/${round.id}`;
                    this.props.history.push(url);
                  }}
                  style={{ textDecoration: "underline", color: "#008000" }}
                >
                  <i
                    className="mdi mdi-account-plus-outline font-size-18"
                    id="participantsIcon"
                  ></i>
                </Link>
              </Tooltip>

              <Tooltip title="Update">
                <Link className="text-success" to="#">
                  <i
                    className="mdi mdi-pencil font-size-18"
                    id="edittooltip"
                    onClick={() => this.toggle(round)}
                  ></i>
                </Link>
              </Tooltip>

              {/* ✅ Statistics Icons - isCalculated se color change hoga */}
              {(round.status === "Closed" ||
                round.status === "Statistics Done") && (
                <>
                  {/* Quantitative: GREEN → RED when calculated */}
                  {round.scheme_type === "Quantitative" && (
                    <Tooltip title="Statistics">
                      <Link
                        to={`/${this.state.organization_name}/statistics/${round.id}`}
                        style={{
                          textDecoration: "underline",
                          color: isCalculated ? "red" : "#008000",
                        }}
                      >
                        <i className="mdi mdi-chart-bar font-size-18" />
                      </Link>
                    </Tooltip>
                  )}

                  {/* Qualitative: BLUE → RED when calculated */}
                  {round.scheme_type === "Qualitative" && (
                    <Tooltip title="Qualitative Statistics">
                      <Link
                        to={`/${this.state.organization_name}/qualitativeStatic/${round.id}`}
                        style={{
                          textDecoration: "underline",
                          color: isCalculated ? "red" : "#007BFF",
                        }}
                      >
                        <i className="mdi mdi-chart-bar font-size-18" />
                      </Link>
                    </Tooltip>
                  )}

                  {/* Identification: BLUE → RED when calculated */}
                  {round.scheme_type === "Identification" && (
                    <Tooltip title="Identification Statistics">
                      <Link
                        to={`/${this.state.organization_name}/microReportStatistics/${round.id}`}
                        style={{
                          textDecoration: "underline",
                          color: isCalculated ? "red" : "#007BFF",
                        }}
                      >
                        <i className="mdi mdi-chart-bar font-size-18" />
                      </Link>
                    </Tooltip>
                  )}
                </>
              )}

              {(round.status === "Created" || round.status === "Ready") && (
                <Tooltip title="Delete">
                  <Link className="text-danger" to="#">
                    <i
                      className="mdi mdi-delete font-size-18"
                      id="deletetooltip"
                      onClick={() => this.onClickDelete(round)}
                    ></i>
                  </Link>
                </Tooltip>
              )}

              <Tooltip title="History">
                <Link
                  className="fas fa-comment font-size-18"
                  to={`/${organization_name}/rounds-history/${round.id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    if (!this.state.organization_name) {
                      console.error("Invalid organization name");
                      return;
                    }
                    const url = `/${this.state.organization_name}/rounds-history/${round.id}`;
                    this.props.history.push(url);
                  }}
                ></Link>
              </Tooltip>
            </div>
          );
        },
      },
    ];

    const filteredData = (RoundList || []).filter((entry) => {
      // Modify accordingly for each filter condition
      const id = entry.id ? entry.id.toString() : "";
      const rounds = entry.rounds ? entry.rounds.toString() : "";
      const scheme_name = entry.scheme_name
        ? entry.scheme_name.toString().toLowerCase()
        : "";
      const cycle_no = entry.cycle_no
        ? entry.cycle_no.toString().toLowerCase()
        : "";
      const sample = entry.sample ? entry.sample.toString() : "";
      const participants = entry.participants
        ? entry.participants.toString()
        : "";
      const issue_date = entry.issue_date ? entry.issue_date.toString() : "";
      const closing_date = entry.closing_date
        ? entry.closing_date.toString()
        : "";
      const note = entry.note ? entry.note.toString() : "";
      const status = entry.status ? entry.status.toString() : "";
      const round_sample_condition = entry.round_sample_condition
        ? entry.round_sample_condition.toString()
        : "";
      const scheme_type = entry.scheme_type ? entry.scheme_type.toString() : "";

      const matchesScheme =
        !this.state.selectedSchemeId ||
        entry.scheme?.toString() === this.state.selectedSchemeId.toString();

      return (
        id.includes(idFilter) &&
        rounds.includes(roundsFilter) &&
        scheme_name.includes(schemenameFilter.toLowerCase()) &&
        cycle_no.includes(cyclenoFilter.toLowerCase()) &&
        sample.includes(sampleFilter) &&
        participants.includes(participantsFilter) &&
        issue_date.includes(issuedateFilter) &&
        closing_date.includes(closingdateFilter) &&
        note.includes(notesFilter) &&
        status.includes(statusFilter) &&
        matchesScheme
        // scheme_type
      );
    });
    const totalPages = filteredData?.total_pages || 0;
    const filteredDatasData = filteredData || [];
    const data = this.state.data;
    // const { onGetRoundList } = this.props;
    const pageOptions = {
      sizePerPage: 100,
      // totalSize: RoundList.length,
      totalSize: filteredData.length,
      custom: true,
    };
    const pageRange = 3; // Adjust this value based on your requirement
    let startPage = Math.max(1, currentPage - Math.floor(pageRange / 2));
    let endPage = Math.min(totalPages, startPage + pageRange - 1);

    // Adjust startPage and endPage to always show pageRange page numbers
    if (endPage - startPage + 1 < pageRange) {
      startPage = Math.max(1, endPage - pageRange + 1);
    }

    // Render the page numbers
    const pageNumbers = Array.from(
      { length: endPage - startPage + 1 },
      (_, index) => startPage + index,
    );
    const defaultSorted = [
      {
        dataField: "id",
        order: "desc",
      },
    ];

    return (
      <React.Fragment>
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteRound}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />

        {/* ✅ "Open For" sub-modal — appears when user selects status "Open".
            Lets them mark the round as opened for Customer Service,
            Participant, or Both before the status change is committed. */}
        <Modal isOpen={this.state.openForModal} toggle={this.closeOpenForModal}>
          <ModalHeader toggle={this.closeOpenForModal} tag="h5">
            Who is this round being opened for?
          </ModalHeader>
          <ModalBody>
            <p>
              Select who should be notified / who this round is being opened
              for. This will be saved with the round.
            </p>
            <div className="d-flex flex-column gap-2">
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={() => this.handleOpenForSelect("Customer_Service")}
              >
                Customer Service
              </button>
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={() => this.handleOpenForSelect("Participant")}
              >
                Participant
              </button>
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={() => this.handleOpenForSelect("Both")}
              >
                Both
              </button>
            </div>
          </ModalBody>
        </Modal>

        <div className="page-content">
          <MetaTags>
            <title>Registeration Admin | Round List</title>
          </MetaTags>
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="List" breadcrumbItem="Round List" />
            <Row className="justify-content-center">
              <Col lg="10">
                <Card>
                  <CardBody>
                    <Row>
                      <Col className="pagination pagination-rounded justify-content-center mb-2">
                        {errorMessage && (
                          <Alert color="danger">{errorMessage}</Alert>
                        )}
                      </Col>
                    </Row>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={feedbackListColumns}
                      data={filteredDatasData}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={feedbackListColumns}
                          data={filteredDatasData}
                          search
                        >
                          {(toolkitprops) => (
                            <React.Fragment>
                              <Row className="mb-4">
                                <Col
                                  xs={12}
                                  sm={6}
                                  md={4}
                                  lg={3}
                                  className="mb-3"
                                >
                                  <select
                                    className="form-select"
                                    onChange={(e) =>
                                      this.setState({
                                        selectedSchemeId: e.target.value,
                                      })
                                    }
                                    value={this.state.selectedSchemeId}
                                  >
                                    <option value="">Filter by Scheme</option>
                                    {Array.isArray(this.state.SchemeList) &&
                                    Array.isArray(this.props.RoundList) &&
                                    this.state.SchemeList.length > 0 ? (
                                      this.state.SchemeList.filter((scheme) =>
                                        this.props.RoundList.some(
                                          (round) =>
                                            round.scheme?.toString() ===
                                            scheme.id.toString(),
                                        ),
                                      ).map((scheme) => (
                                        <option
                                          key={scheme.id}
                                          value={scheme.id}
                                        >
                                          {scheme.scheme_name ||
                                            scheme.name ||
                                            "Unnamed Scheme"}
                                        </option>
                                      ))
                                    ) : (
                                      <option disabled>
                                        No Schemes Available
                                      </option>
                                    )}
                                  </select>
                                </Col>

                                <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                  <Col className="text-end">
                                    <button
                                      className="btn btn-primary btn-block mb-4"
                                      onClick={() => this.toggle()}
                                      style={{ background: "#0000CD" }}
                                    >
                                      Add Rounds
                                    </button>
                                    <Modal
                                      isOpen={this.state.modal}
                                      className={this.props.className}
                                    >
                                      <ModalHeader
                                        toggle={this.closeModal}
                                        tag="h4"
                                      >
                                        {"Round Form"}
                                      </ModalHeader>
                                      <ModalBody>
                                        {this.state.successMessage && (
                                          <div
                                            className="alert alert-success"
                                            role="alert"
                                          >
                                            {this.state.successMessage}
                                          </div>
                                        )}
                                        <Formik
                                          enableReinitialize={true}
                                          initialValues={{
                                            rounds: this.state.selectedRound
                                              ? this.state.selectedRound.rounds
                                              : "",
                                            round_period: this.state
                                              .selectedRound
                                              ? this.state.selectedRound
                                                  .round_period || ""
                                              : "",
                                            scheme:
                                              this.state.selectedFormSchemeId ||
                                              "",

                                            sample: this.state.selectedRound
                                              ? this.state.selectedRound.sample
                                              : "",
                                            participants: this.state
                                              .selectedRound
                                              ? this.state.selectedRound
                                                  .participants
                                              : "",
                                            cycle_no: this.state.selectedCycle
                                              ? String(this.state.selectedCycle)
                                              : "", // ✅ Ensure it's a string
                                            issue_date: this.state.selectedRound
                                              ? this.state.selectedRound
                                                  .issue_date
                                              : "",
                                            closing_date: this.state
                                              .selectedRound
                                              ? this.state.selectedRound
                                                  .closing_date
                                              : "",
                                            round_sample_condition: this.state
                                              .selectedRound
                                              ? this.state.selectedRound
                                                  .round_sample_condition
                                              : "",
                                            note: this.state.selectedRound
                                              ? this.state.selectedRound.note
                                              : "",
                                            status: this.state.selectedRound
                                              ? this.state.selectedRound.status
                                              : "Created",
                                            // ✅ who this round is opened for (Customer Service / Participant / Both)
                                            open_for: this.state.selectedRound
                                              ? this.state.selectedRound
                                                  .open_for || ""
                                              : "",
                                          }}
                                          validationSchema={Yup.object().shape({
                                            rounds: Yup.string().required(
                                              "Round number is required",
                                            ),
                                            scheme:
                                              Yup.string().required(
                                                "Scheme is required",
                                              ),
                                            cycle_no: Yup.string().required(
                                              "Cycle number is required",
                                            ), // ✅ Ensure validation is expecting a string
                                            issue_date: Yup.string().required(
                                              "Issue date is required",
                                            ),
                                            closing_date: Yup.string().required(
                                              "Closing date is required",
                                            ),
                                            round_period: Yup.string().required(
                                              "Please select round period",
                                            ),
                                            // note: Yup.string().required(
                                            //   "Note is required"
                                            // ),
                                            sample: this.state.isEdit
                                              ? Yup.string().required(
                                                  "Sample is required",
                                                )
                                              : Yup.string(),
                                            status: this.state.isEdit
                                              ? Yup.string().required(
                                                  "Status is required",
                                                )
                                              : Yup.string(),
                                            // ✅ Required only when status is being set to "Open"
                                            open_for: Yup.string().when(
                                              "status",
                                              {
                                                is: "Open",
                                                then: (schema) =>
                                                  schema.required(
                                                    "Please select who this round is opened for",
                                                  ),
                                                otherwise: (schema) => schema,
                                              },
                                            ),
                                          })}
                                          onSubmit={async (
                                            values,
                                            {
                                              setSubmitting,
                                              setFieldValue,
                                              handleChange,
                                              errors,
                                              touched,
                                            },
                                          ) => {
                                            const userId = localStorage.getItem(
                                              "authUser",
                                            )
                                              ? JSON.parse(
                                                  localStorage.getItem(
                                                    "authUser",
                                                  ),
                                                ).user_id
                                              : "";

                                            const newround = {
                                              rounds: values.rounds,
                                              round_period: values.round_period,
                                              scheme: values.scheme,
                                              sample: this.state.selectedSample,
                                              cycle_no: values.cycle_no,
                                              participants: values.participants,
                                              issue_date: values.issue_date,
                                              closing_date: values.closing_date,
                                              round_sample_condition:
                                                values.round_sample_condition,
                                              note: values.note,
                                              status: values.status,
                                              open_for: values.open_for,
                                              added_by: userId,
                                            };

                                            try {
                                              if (this.state.isEdit) {
                                                await this.props.onUpdateRound(
                                                  this.state.selectedRound.id,
                                                  newround,
                                                );
                                                this.displaySuccessMessage(
                                                  "Round updated successfully!",
                                                );
                                              } else {
                                                await this.props.onAddNewRound(
                                                  newround,
                                                );
                                                this.displaySuccessMessage(
                                                  "Round added successfully!",
                                                );
                                              }

                                              // Update the sample's status to "Rounded" once it's attached to a round.
                                              if (values.sample) {
                                                const sampleToUpdate =
                                                  this.props.ListUnitt.find(
                                                    (sample) =>
                                                      sample.samplename ===
                                                      values.sample,
                                                  );
                                                if (sampleToUpdate) {
                                                  // ✅ Sample.cycle_no is a ForeignKey to Cycle — the backend needs
                                                  // the Cycle row's numeric id, not the display cycle_no string
                                                  // ("04"). Resolve it from CycleList by matching cycle_no + scheme.
                                                  const matchingCycle =
                                                    this.props.CycleList.find(
                                                      (cycle) =>
                                                        cycle.cycle_no?.toString() ===
                                                          sampleToUpdate.cycle_no?.toString() &&
                                                        cycle.scheme_id ===
                                                          sampleToUpdate.scheme_id,
                                                    );

                                                  const updatedSample = {
                                                    ...sampleToUpdate,
                                                    status: "Rounded",
                                                    added_by: userId,
                                                    cycle_no: matchingCycle
                                                      ? matchingCycle.id
                                                      : sampleToUpdate.cycle_no, // fallback if no match found
                                                  };
                                                  await this.props.onUpdateSampleList(
                                                    updatedSample,
                                                  );
                                                }
                                              }

                                              setTimeout(async () => {
                                                const updatedData =
                                                  await this.props.onGetRoundList(
                                                    this.state.user_id,
                                                  );
                                                this.setState({
                                                  RoundList: updatedData,
                                                });
                                              }, 300);
                                            } catch (error) {
                                              console.error(
                                                "Error updating/adding rounds:",
                                                error,
                                              );
                                            }

                                            setSubmitting(false);
                                          }}
                                        >
                                          {({ errors, touched }) => (
                                            <Form>
                                              <Row>
                                                <Col className="col-12">
                                                  <Field name="scheme">
                                                    {({ field, form }) => (
                                                      <div className="mb-3">
                                                        <label htmlFor="scheme">
                                                          Select Scheme
                                                        </label>
                                                        <select
                                                          {...field}
                                                          className={`form-control${
                                                            form.errors
                                                              .scheme &&
                                                            form.touched.scheme
                                                              ? " is-invalid"
                                                              : ""
                                                          }`}
                                                          value={
                                                            this.state
                                                              .selectedFormSchemeId ||
                                                            ""
                                                          }
                                                          onChange={(e) => {
                                                            const value =
                                                              e.target.value;
                                                            form.setFieldValue(
                                                              "scheme",
                                                              value,
                                                            );
                                                            this.setState({
                                                              selectedFormSchemeId:
                                                                value,
                                                            }); // ✅ update form-only value
                                                            this.handleSchemeChange(
                                                              {
                                                                target: {
                                                                  value,
                                                                },
                                                              },
                                                            ); // ⚠️ if handleSchemeChange still sets selectedSchemeId, fix it too
                                                          }}
                                                          disabled={
                                                            this.state.isEdit
                                                          }
                                                        >
                                                          <option value="">
                                                            Select Scheme
                                                          </option>
                                                          {this.state.SchemeList.map(
                                                            (scheme) => (
                                                              <option
                                                                key={scheme.id}
                                                                value={
                                                                  scheme.id
                                                                }
                                                              >
                                                                {scheme.name}
                                                              </option>
                                                            ),
                                                          )}
                                                        </select>
                                                        <ErrorMessage
                                                          name="scheme"
                                                          component="div"
                                                          className="invalid-feedback"
                                                        />
                                                      </div>
                                                    )}
                                                  </Field>

                                                  <ErrorMessage
                                                    name="scheme"
                                                    component="div"
                                                    className="invalid-feedback"
                                                  />

                                                  <div className="mb-3">
                                                    <Label className="col-form-label">
                                                      Round Number
                                                    </Label>
                                                    <Field
                                                      name="rounds"
                                                      type="text"
                                                      className="form-control"
                                                    />
                                                    <ErrorMessage
                                                      name="rounds"
                                                      component="div"
                                                      className="text-danger"
                                                    />
                                                  </div>
                                                  {/* 👇 New Round (Previous / Current / Next) dropdown */}
                                                  <div className="mb-3">
                                                    <Label className="col-form-label">
                                                      Round
                                                    </Label>
                                                    <Field name="round_period">
                                                      {({ field, form }) => (
                                                        <>
                                                          <select
                                                            {...field}
                                                            className={`form-control${
                                                              form.errors
                                                                .round_period &&
                                                              form.touched
                                                                .round_period
                                                                ? " is-invalid"
                                                                : ""
                                                            }`}
                                                          >
                                                            <option value="">
                                                              Select Round
                                                            </option>
                                                            <option value="Previous">
                                                              Previous
                                                            </option>
                                                            <option value="Current">
                                                              Current
                                                            </option>
                                                            <option value="Next">
                                                              Next
                                                            </option>
                                                          </select>
                                                        </>
                                                      )}
                                                    </Field>
                                                    <ErrorMessage
                                                      name="round_period"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </div>
                                                  <div className="mb-3">
                                                    {/* <label htmlFor="cycle_no">
                                                      Select Cycle
                                                    </label> */}
                                                    <Field name="cycle_no">
                                                      {({ field, form }) => (
                                                        <div className="mb-3">
                                                          <label htmlFor="cycle_no">
                                                            Select Cycle
                                                          </label>
                                                          <select
                                                            {...field}
                                                            className={`form-control${
                                                              form.errors
                                                                .cycle_no &&
                                                              form.touched
                                                                .cycle_no
                                                                ? " is-invalid"
                                                                : ""
                                                            }`}
                                                            disabled={
                                                              this.state.isEdit
                                                            } // ✅ Disable only in Edit Mode
                                                          >
                                                            <option value="">
                                                              Select Cycle
                                                            </option>
                                                            {this.state.filteredCycleList
                                                              .filter(
                                                                (cycle) =>
                                                                  cycle.status &&
                                                                  cycle.status.toLowerCase() ===
                                                                    "active",
                                                              )
                                                              .map((cycle) => (
                                                                <option
                                                                  key={cycle.id}
                                                                  value={String(
                                                                    cycle.cycle_no,
                                                                  )}
                                                                >
                                                                  {" "}
                                                                  {/* Use cycle_no instead */}
                                                                  {
                                                                    cycle.cycle_no
                                                                  }
                                                                </option>
                                                              ))}
                                                          </select>
                                                          <ErrorMessage
                                                            name="cycle_no"
                                                            component="div"
                                                            className="invalid-feedback"
                                                          />
                                                        </div>
                                                      )}
                                                    </Field>

                                                    <ErrorMessage
                                                      name="cycle_no"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </div>

                                                  <div className="mb-3">
                                                    <Label className="col-form-label">
                                                      Issue Date
                                                    </Label>
                                                    <Field
                                                      name="issue_date"
                                                      type="date"
                                                      id="issue_date"
                                                      className={
                                                        "form-control" +
                                                        (errors.issue_date &&
                                                        touched.issue_date
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                    />
                                                    <ErrorMessage
                                                      name="issue_date"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </div>
                                                  <div className="mb-3">
                                                    <Label className="col-form-label">
                                                      Closing Date
                                                    </Label>
                                                    <Field
                                                      name="closing_date"
                                                      type="date"
                                                      id="closing_date"
                                                      className={
                                                        "form-control" +
                                                        (errors.closing_date &&
                                                        touched.closing_date
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                    />
                                                    <ErrorMessage
                                                      name="closing_date"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </div>
                                                  <div className="mb-3">
                                                    <Label className="col-form-label">
                                                      Notes
                                                    </Label>
                                                    <Field
                                                      name="note"
                                                      type="text"
                                                      className="form-control"
                                                    />
                                                    <ErrorMessage
                                                      name="note"
                                                      component="div"
                                                      className="text-danger"
                                                    />
                                                  </div>
                                                  {/* Only render Sample and Status fields if editing */}
                                                  {this.state.isEdit && (
                                                    <>
                                                      <div className="mb-3">
                                                        <Label for="sample">
                                                          Sample
                                                        </Label>
                                                        <Field name="sample">
                                                          {({
                                                            field,
                                                            form,
                                                          }) => (
                                                            <select
                                                              {...field}
                                                              className={`form-control${
                                                                form.errors
                                                                  .sample &&
                                                                form.touched
                                                                  .sample
                                                                  ? " is-invalid"
                                                                  : ""
                                                              }`}
                                                              value={
                                                                this.state
                                                                  .selectedSample ||
                                                                ""
                                                              } // Set the default value
                                                              onChange={(e) => {
                                                                this.setState({
                                                                  selectedSample:
                                                                    e.target
                                                                      .value,
                                                                }); // Update the state
                                                                form.setFieldValue(
                                                                  "sample",
                                                                  e.target
                                                                    .value,
                                                                ); // Update the form value
                                                              }}
                                                              disabled={[
                                                                "Ready",
                                                                "Open",
                                                                "Closed",
                                                                "Report Available",
                                                              ].includes(
                                                                form.values
                                                                  .status,
                                                              )} // Disable based on status
                                                            >
                                                              <option value="">
                                                                Select Sample
                                                              </option>
                                                              {this.state.filteredSampleList.map(
                                                                (sample) => (
                                                                  <option
                                                                    key={
                                                                      sample.id
                                                                    }
                                                                    value={
                                                                      sample.samplename
                                                                    }
                                                                  >
                                                                    {
                                                                      sample.samplename
                                                                    }
                                                                  </option>
                                                                ),
                                                              )}
                                                            </select>
                                                          )}
                                                        </Field>
                                                        <ErrorMessage
                                                          name="sample"
                                                          component="div"
                                                          className="invalid-feedback"
                                                        />
                                                      </div>
                                                      <div>
                                                        <Field name="round_sample_condition">
                                                          {({
                                                            field,
                                                            form,
                                                          }) => (
                                                            <div className="mb-3">
                                                              <Label
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                Sample Condition
                                                              </Label>
                                                              <select
                                                                {...field}
                                                                className="form-select"
                                                                value={
                                                                  this.state
                                                                    .selectedSampleCondition ||
                                                                  ""
                                                                }
                                                                onChange={(
                                                                  e,
                                                                ) => {
                                                                  this.setState(
                                                                    {
                                                                      selectedSampleCondition:
                                                                        e.target
                                                                          .value,
                                                                    },
                                                                  );
                                                                  {
                                                                    /* ✅ Add this */
                                                                  }
                                                                  form.setFieldValue(
                                                                    "round_sample_condition",
                                                                    e.target
                                                                      .value,
                                                                  );
                                                                  {
                                                                    /* ✅ Add this */
                                                                  }
                                                                }}
                                                              >
                                                                <option value="">
                                                                  Select Sample
                                                                  Condition
                                                                </option>
                                                                <option value="Clear">
                                                                  Clear
                                                                </option>
                                                                <option value="Clotted">
                                                                  Clotted
                                                                </option>
                                                                <option value="Hemolyzed">
                                                                  Hemolyzed
                                                                </option>
                                                                <option value="Icteric">
                                                                  Icteric
                                                                </option>
                                                                <option value="Lipemic">
                                                                  Lipemic
                                                                </option>
                                                              </select>
                                                            </div>
                                                          )}
                                                        </Field>
                                                      </div>
                                                      <div className="mb-3">
                                                        <Label className="col-form-label">
                                                          Status
                                                        </Label>
                                                        {/* ✅ Render-prop form so we can intercept the
                                                            change to "Open" and pop the Open-For modal
                                                            *before* the status is actually committed. */}
                                                        <Field name="status">
                                                          {({
                                                            field,
                                                            form,
                                                          }) => (
                                                            <>
                                                              <select
                                                                {...field}
                                                                className={`form-control${
                                                                  form.errors
                                                                    .status &&
                                                                  form.touched
                                                                    .status
                                                                    ? " is-invalid"
                                                                    : ""
                                                                }`}
                                                                onChange={(
                                                                  e,
                                                                ) => {
                                                                  const value =
                                                                    e.target
                                                                      .value;
                                                                  if (
                                                                    value ===
                                                                    "Open"
                                                                  ) {
                                                                    // Hold off committing "Open" —
                                                                    // ask who it's for first.
                                                                    this.setState(
                                                                      {
                                                                        openForModal: true,
                                                                        pendingFormik:
                                                                          form,
                                                                      },
                                                                    );
                                                                  } else {
                                                                    form.setFieldValue(
                                                                      "status",
                                                                      value,
                                                                    );
                                                                    // Clear open_for when moving away from Open
                                                                    form.setFieldValue(
                                                                      "open_for",
                                                                      "",
                                                                    );
                                                                  }
                                                                }}
                                                              >
                                                                <option value="Ready">
                                                                  Ready
                                                                </option>
                                                                <option value="Open">
                                                                  Open
                                                                </option>
                                                                <option value="Closed">
                                                                  Closed
                                                                </option>
                                                                <option value="Aborted">
                                                                  Aborted
                                                                </option>
                                                                {this.state
                                                                  .statisticsStatusMap?.[
                                                                  this.state
                                                                    .selectedRound
                                                                    ?.id
                                                                ] === true && (
                                                                  <option value="Report Available">
                                                                    Report
                                                                    Available
                                                                  </option>
                                                                )}
                                                              </select>
                                                              {/* Show who this round is currently
                                                                  opened for, once status is Open */}
                                                              {form.values
                                                                .status ===
                                                                "Open" &&
                                                                form.values
                                                                  .open_for && (
                                                                  <div
                                                                    className="mt-2"
                                                                    style={{
                                                                      fontSize:
                                                                        "0.9em",
                                                                    }}
                                                                  >
                                                                    Opened for:{" "}
                                                                    <strong>
                                                                      {
                                                                        form
                                                                          .values
                                                                          .open_for
                                                                      }
                                                                    </strong>{" "}
                                                                    <Link
                                                                      to="#"
                                                                      onClick={(
                                                                        e,
                                                                      ) => {
                                                                        e.preventDefault();
                                                                        this.setState(
                                                                          {
                                                                            openForModal: true,
                                                                            pendingFormik:
                                                                              form,
                                                                          },
                                                                        );
                                                                      }}
                                                                    >
                                                                      (change)
                                                                    </Link>
                                                                  </div>
                                                                )}
                                                            </>
                                                          )}
                                                        </Field>
                                                        <ErrorMessage
                                                          name="status"
                                                          component="div"
                                                          className="text-danger"
                                                        />
                                                        <ErrorMessage
                                                          name="open_for"
                                                          component="div"
                                                          className="text-danger"
                                                        />
                                                      </div>
                                                    </>
                                                  )}
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col>
                                                  <div className="text-end">
                                                    <button
                                                      type="submit"
                                                      className="btn btn-success save-user"
                                                      style={{
                                                        backgroundColor:
                                                          "#0000CD",
                                                        borderColor: "#0000CD",
                                                      }}
                                                    >
                                                      Save
                                                    </button>
                                                  </div>
                                                </Col>
                                              </Row>
                                            </Form>
                                          )}
                                        </Formik>
                                      </ModalBody>
                                    </Modal>
                                  </Col>
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      key={JSON.stringify(
                                        this.state.statisticsStatusMap,
                                      )}
                                      defaultSorted={defaultSorted}
                                      classes={"table align-middle table-hover"}
                                      bordered={false}
                                      striped={true}
                                      headerWrapperClasses={
                                        "table-header-sky-blue"
                                      }
                                      responsive
                                      ref={this.node}
                                      filter={filterFactory()}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

InstrumentType.propTypes = {
  match: PropTypes.object,
  RoundList: PropTypes.array,
  SchemeList: PropTypes.array,
  CycleList: PropTypes.array,
  // sample: PropTypes.array,
  ListUnitt: PropTypes.array,
  className: PropTypes.any,
  onGetRoundList: PropTypes.func,
  onGetgetschemelist: PropTypes.func,
  onGetgetcyclelist: PropTypes.func,
  onGetgetSamplelistlist: PropTypes.func,
  createInstrumentType: PropTypes.array,
  error: PropTypes.any,
  success: PropTypes.any,
  onAddNewRound: PropTypes.func,
  onUpdateRound: PropTypes.func,
  onDeleteRound: PropTypes.func,
  onUpdateSampleList: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = ({
  RoundList,
  SchemeList,
  CycleList,
  sample,
  ListUnitt,
}) => ({
  RoundList: RoundList.RoundList,
  SchemeList: SchemeList.SchemeList,
  // sample: sample.sample,
  CycleList: CycleList.CycleList,
  ListUnitt: ListUnitt.ListUnitt,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onGetgetschemelist: (id) => dispatch(getSchemelist(id)),
  onGetgetcyclelist: (id) => dispatch(getcyclelist(id)),
  onGetgetSamplelistlist: (id) => dispatch(getSamplelist(id)),
  onGetRoundList: (id, page, limit, filters) =>
    dispatch(getroundlist(id, page, limit, filters)),
  onAddNewRound: (id, createround) =>
    dispatch(addNewRoundList(id, createround)),
  onUpdateRound: (id, round) => dispatch(updateRoundList({ id, ...round })),
  onDeleteRound: (round) => dispatch(deleteRound(round)),
  onUpdateSampleList: (sample) => dispatch(updateSampleList(sample)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(InstrumentType));
